const project4 = {
  id: "project4",
  title:
    "SageMath Auto-Grader – Docker-Based Notebook Evaluation System for Automated SageMath Assignment Grading",
  dates: "Feb 2025 - Apr 2025",
  description: [
    "Built an automated SageMath grading system for evaluating student notebook submissions in a consistent containerized environment.",
    "Used Python and Jupyter-based workflows to process SageMath notebooks and simplify assignment evaluation across different systems.",
    "Integrated Docker to eliminate local setup issues and ensure the same grading environment on Windows, Mac, and Linux.",
    "Structured the project for scalable deployment workflows with clean automation, reproducible execution, and maintainable grading operations."
  ],
  techStack: ["python", "docker", "kubernetes", "jupyter"],
  thumbnail: process.env.PUBLIC_URL + "/images/projects/projects4.png"
};

export default project4;